import { signInWithPopup } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, provider, db } from "../firebase";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const nav = useNavigate();

  const signIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const ref = doc(db, "users", user.uid);
      const existing = await getDoc(ref);
      const data = existing.exists() ? existing.data() : {};
      if (!existing.exists()) {
        await setDoc(ref, {
          uid: user.uid,
          displayName: user.displayName || "",
          displayNameLower: (user.displayName || "").toLowerCase(),
          photoURL: user.photoURL || "",
          email: user.email || "",
          normalizedEmail: (user.email || "").toLowerCase().trim(),
        });
      }
      nav(data.displayName?.trim() || user.displayName?.trim() ? "/chat" : "/username", { replace: true });
    } catch (error) {
      console.error("Google sign-in failed", error);
    }
  };

  return (
    <main className="auth-shell">
      <section className="auth-box auth-box-modern">
        <div className="brand-mark">✒</div>
        <div className="brand-wordmark">Pen Messenger</div>
        <p className="auth-subtitle">Fast, clean messaging for the Pen network.</p>
        <button className="google-login" onClick={signIn}>
          <span className="google-g">G</span>
          Continue with Google
        </button>
        <p className="auth-note">Your chats sync securely across devices.</p>
      </section>
    </main>
  );
}
